import React from 'react';
import { Link } from 'react-router-dom';

const Service = (props) => {
    const title = props.link ? (
        <Link to={props.link} className="fables-main-text-color">
            {props.title}
        </Link>
    ) : (
        props.title
    );
    return (
        <div className="col-12 col-sm-6 col-lg-3 text-center mb-4 mb-sm-5 icon-pop" data-reveal="up" data-reveal-delay={String(((props.index || 0) % 4) + 1)}>
            <span className={props.icon} aria-hidden="true"></span>
            <h3 className="fables-main-text-color font-18 my-2">
                {title}
            </h3>
            <p className="fables-forth-text-color font-15">
                {props.description}
            </p>
            {props.link && (
                <Link to={props.link} className="fables-second-text-color font-14 font-weight-bold">
                    Ver más <span aria-hidden="true">→</span>
                </Link>
            )}
        </div>
    );
};

export default Service;
